import { useState } from 'react'
import { useRouter } from 'next/router'
import { CheckoutSuccess as View } from 'ui-components'
const CheckoutSuccess = () => {
  const [open, setOpen] = useState(true)
  const router = useRouter()
  const handleClose = () => {
    setOpen(false)
  }
  if (router.query?.checkout === 'success')
    return (
      <View
        open={open}
        onClose={handleClose}
      />
    )
  return null
}

export { CheckoutSuccess }
